
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import rateTime from "@/components/pi-rate-time/pi-rate-time.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-rate-time": rateTime
  }
})
export default class PiModelAddEateTable extends Vue {
  @Prop({ default: true }) private isAdd!: boolean;
  @Prop({ default: "ac" }) private type!: string;

  private maxRate = 2;
  private typeName: objAny = {
    ac: i18n.t("addRatamanage.acRate"),
    dc: i18n.t("addRatamanage.dcRate"),
    delay: i18n.t("addRatamanage.delayRate")
  };
  private slotFlagTextAC = [
    i18n.t("ratamanage.jian"),
    i18n.t("ratamanage.feng"),
    i18n.t("ratamanage.ping"),
    i18n.t("ratamanage.gu")
  ];
  private tableListInit: object[] = [
    {
      slotFlag: 1,
      beginTime: 0,
      endTime: 0,
      slotElecPrice: "",
      slotServicePrice: "",
      time: []
    },
    {
      slotFlag: 2,
      beginTime: 0,
      endTime: 0,
      slotElecPrice: "",
      slotServicePrice: "",
      time: []
    },
    {
      slotFlag: 3,
      beginTime: 0,
      endTime: 0,
      slotElecPrice: "",
      slotServicePrice: "",
      time: []
    },
    {
      slotFlag: 4,
      beginTime: 0,
      endTime: 0,
      slotElecPrice: "",
      slotServicePrice: "",
      time: []
    }
  ];

  private tableListAC: object[] = [];
  private tableColumnsAC: object[] = [
    {
      title: i18n.t("addRatamanage.slotFlag"),
      key: "slotFlag",
      resizable: true,
      width: 80,
      slot: "slotFlag"
    },
    {
      title: i18n.t("addRatamanage.slotElecPrice"),
      key: "slotElecPrice",
      resizable: true,
      slot: "slotElecPrice",
      width: 120
    },
    {
      title: i18n.t("addRatamanage.slotServicePrice"),
      key: "slotServicePrice",
      resizable: true,
      slot: "slotServicePrice",
      width: 120
    },
    {
      title: i18n.t("addRatamanage.timeValue"),
      key: "timeValue",
      resizable: true,
      minWidth: 130,
      slot: "timeValue"
    }
  ];

  public initData(list?: object[]): void {
    const data = JSON.parse(JSON.stringify(this.tableListInit));
    console.log(data);
    if (!list) {
      this.tableListAC = data;
    } else {
      const tableList: object[] = [];
      data.map((item: objAny) => {
        const time: object[] = [];
        let hasArchive = false;
        let pkid = "";
        let elecFeePkId = "";
        let slotElecPrice = "";
        let slotServicePrice = "";
        let delayFeePkId = "";
        list.map((li: objAny) => {
          const beginTime = this.convertStringToTimes(li.beginTime);
          const endTime = this.convertStringToTimes(li.endTime);
          if (item.slotFlag == li.slotFlag) {
            time.push([beginTime, endTime]);
            pkid = li.pkid;
            hasArchive = li.hasArchive;
            elecFeePkId = li.elecFeePkId;

            slotServicePrice = li.slotServicePrice;
            if (li.delayFeePkId) {
              slotElecPrice = li.slotDelayPrice;
              delayFeePkId = li.delayFeePkId;
            } else {
              slotElecPrice = li.slotElecPrice;
            }
          }
        });
        item.time = time;
        item.pkid = pkid;
        item.hasArchive = hasArchive;
        item.elecFeePkId = elecFeePkId;
        item.slotElecPrice = slotElecPrice; // 电价和延时费都是用它

        if (this.type == "delay") {
          item.delayFeePkId = delayFeePkId;
        } else {
          item.slotServicePrice = slotServicePrice;
        }
        tableList.push(item);
      });
      this.tableListAC = tableList;
    }
  }

  public blurElecPriceAC(row: objAny, index: number) {
    if (row.slotElecPrice > this.maxRate) {
      row.slotElecPrice = "";

      this.$Message.warning(
        i18n.t("addRatamanage.priceMax") + "" + this.maxRate
      );
      // this.$Message.warning("i18n.t('addRatamanage.priceMax') + ''  + this.maxRate );
    } else if (!(row.slotElecPrice > 0)) {
      row.slotElecPrice = "";
      this.$Message.warning(i18n.t("addRatamanage.pricePl"));
    }
    this.$set(this.tableListAC, index, row);
  }
  public blurServicePriceAC(row: objAny, index: number) {
    if (row.slotServicePrice > this.maxRate) {
      row.slotServicePrice = "";
      this.$Message.warning(
        "i18n.t('addRatamanage.priceMax') " + "" + this.maxRate
      );
    } else if (!(row.slotElecPrice > 0)) {
      row.slotServicePrice = "";
      this.$Message.warning(i18n.t("addRatamanage.pricePl"));
    }
    this.$set(this.tableListAC, index, row);
  }
  // public timeChange(row: objAny, index: number): void {
  public timeChange(value: string, data: objAny): void {
    // console.log(this.isHasRepeatTime());
    this.$set(this.tableListAC, data.index, data.row);
  }
  public addTime(row: objAny, index: number) {
    if (row.time.length > 0 && row.time[row.time.length - 1][0] == "") {
      this.$Message.warning(i18n.t("addRatamanage.selectTimePl"));
    } else {
      if (this.isTime24().length == 0) {
        this.$Message.warning(i18n.t("addRatamanage.timeNoSelect"));
      } else {
        if (row.time.length == 0) {
          row.time.push(["00:00", "24:00"]);
        } else {
          const start = row.time[row.time.length - 1][1];
          const end = "24:00";
          row.time.push([start, end]);
        }

        this.$set(this.tableListAC, index, row);
      }
    }
  }
  public removeTime(row: objAny, index: number, i: number): void {
    row.time.splice(i, 1);
    this.$set(this.tableListAC, index, row);
  }

  public loseFocus(val: boolean): void {
    if (!val) {
      const data = this.isHasRepeatTime();
      if (data.result) {
        this.$Message.warning(i18n.t("addRatamanage.timeError"));
      }
    }
  }
  public isTime24(): string[] {
    const list: objAny[] = [];
    this.tableListAC.map((item: objAny) => {
      if (item.time.length > 0) {
        item.time.map((t: string[]) => {
          list.push(t);
        });
      }
    });
    // 1、按分钟把选择中 点 和 点半 的时候筛选出来，结束时间减半小时（不然像结束时间为 10 ， 下个开始为 10点半 这个情况对比不出来，因为10 和 10：30都存在）
    // 2、把24小时每隔半小时间的 按分钟 组成一个数组
    // 3、对比 1 数组对照 2 数组，看有没有漏掉
    const arr = [];
    for (const i in list) {
      const last = list[i][1] == "00:00" ? "24:00" : list[i][1];
      const minTime = list[i][0].split(":");
      const maxTime = last.split(":");

      let maxTime0;
      let maxTime1;

      if (maxTime[0] !== "24") {
        maxTime0 = parseInt(maxTime[0]);
        maxTime1 = parseInt(maxTime[1]);
        if (maxTime1 === 30) {
          maxTime1 = maxTime1 - 30;
        } else if (maxTime1 === 0) {
          maxTime0 = maxTime0 - 1;
          maxTime1 = Math.abs(maxTime1 - 30);
        }
      } else {
        maxTime0 = maxTime[0];
        maxTime1 = maxTime[1];
      }
      const minH = parseInt(minTime[0]);
      const minF = parseInt(minTime[1]);

      const maxH = parseInt(maxTime0);
      const maxF = parseInt(maxTime1);

      for (let k = minH; k <= maxH; k++) {
        if (k === minH && minF > 0) {
          arr.push(k * 60 + 30);
        } else if (k === maxH && maxF === 0) {
          arr.push(k * 60);
        } else {
          arr.push(k * 60);
          arr.push(k * 60 + 30);
        }
      }
    }
    const time = [];
    for (let i = 0; i < 24; i++) {
      time.push(i * 60);
      if (i !== 24) {
        time.push(i * 60 + 30);
      }
    }
    const t: number[] = [];
    for (const i in time) {
      let IsYes = false;
      for (const k in arr) {
        if (arr[k] === time[i]) {
          IsYes = true;
        }
      }
      if (!IsYes) {
        t.push(time[i]);
      }
    }
    const text: string[] = [];
    for (const i in t) {
      const num: number = t[i];
      const n: string = (num / 60).toFixed(0);
      const tt = n + ":" + (num % 60);
      text.push(tt);
    }
    return text;
  }

  public isHasRepeatTime(): objAny {
    const data: objAny[] = [];
    this.tableListAC.map((item: objAny) => {
      if (item.time.length > 0) {
        item.time.map((t: string[]) => {
          data.push(t);
        });
      }
    });
    const startTimeArr: number[] = [];
    const endTimeArr: number[] = [];
    data.map((item: objAny, i: number) => {
      const last = data[i][1] == "00:00" ? "24:00" : data[i][1];
      const minTime = data[i][0];
      const maxTime = last;
      startTimeArr.push(minTime);
      endTimeArr.push(maxTime);
    });
    const allStartTime: number[] = startTimeArr.sort();
    const allEndTime: number[] = endTimeArr.sort();
    let result = 0;
    const arr: number[] = [];
    for (let k = 1; k < allStartTime.length; k++) {
      if (allStartTime[k] < allEndTime[k - 1]) {
        if (arr.indexOf(allStartTime[k]) === -1) {
          arr.push(allStartTime[k]);
        }
        if (arr.indexOf(allEndTime[k - 1]) === -1) {
          arr.push(allEndTime[k - 1]);
        }
        result += 1;
      }
    }
    const json = {
      timeArr: arr,
      result: result > 0
    };
    return json;
  }

  public validate(): boolean {
    const text24 = this.isTime24();
    let isYes = true;
    if (text24.length != 0) {
      this.$Message.warning(
        this.typeName[this.type] + i18n.t("addRatamanage.timeNoSelectSuccess")
      );
      isYes = false;
    } else if (this.isHasRepeatTime().result) {
      this.$Message.warning(
        this.typeName[this.type] + i18n.t("addRatamanage.timeError")
      );
    } else {
      let text = "";
      this.tableListAC.map((item: objAny) => {
        if (item.time.length > 0) {
          if (text == "") {
            if (item.slotElecPrice > this.maxRate) {
              text =
                i18n.t("addRatamanage.slotElecPriceMax") + "" + this.maxRate;
            } else if (
              this.type != "delay" &&
              item.slotServicePrice > this.maxRate
            ) {
              text =
                i18n.t("addRatamanage.slotServicePriceMax") + "" + this.maxRate;
            } else if (item.slotElecPrice === "") {
              const name =
                this.type == "delay"
                  ? i18n.t("addRatamanage.delayRate")
                  : i18n.t("addRatamanage.slotElecPrice");
              text =
                i18n.t("addRatamanage.please") +
                this.typeName[this.type] +
                this.slotFlagTextAC[item.slotFlag - 1] +
                name;
            } else if (this.type != "delay" && item.slotServicePrice === "") {
              text =
                i18n.t("addRatamanage.please") +
                this.typeName[this.type] +
                this.slotFlagTextAC[item.slotFlag - 1] +
                i18n.t("addRatamanage.slotServicePrice");
            }
          }
        }
      });
      if (text != "") {
        isYes = false;
        this.$Message.warning(text);
      }
    }
    return isYes;
  }

  public returnData(): object[] {
    const data: object[] = [];
    this.tableListAC.map((item: objAny) => {
      const timeArr = item.time;
      const slotElecPrice = item.slotElecPrice;
      const slotFlag = item.slotFlag;
      if (this.type == "delay") {
        timeArr.map((t: objAny) => {
          const last = t[1] == "00:00" ? "24:00" : t[1];
          const json: objAny = {
            beginTime: this.convertTimesToString(t[0]),
            endTime: this.convertTimesToString(last),
            slotFlag: slotFlag,
            slotDelayPrice: slotElecPrice
          };
          if (!this.isAdd) {
            json["pkid"] = item.pkid;
            json["hasArchive"] = item.hasArchive;
            json["delayFeePkId"] = item.delayFeePkId;
          }
          data.push(json);
        });
      } else {
        const slotServicePrice = item.slotServicePrice;
        timeArr.map((t: objAny) => {
          const last = t[1] == "00:00" ? "24:00" : t[1];
          const json: objAny = {
            beginTime: this.convertTimesToString(t[0]),
            endTime: this.convertTimesToString(last),
            slotFlag: slotFlag,
            slotElecPrice: slotElecPrice,
            slotServicePrice: slotServicePrice
          };
          if (!this.isAdd) {
            json["pkid"] = item.pkid;
            json["hasArchive"] = item.hasArchive;
            json["delayFeePkId"] = item.delayFeePkId;
            json["elecFeePkId"] = item.elecFeePkId;
          }
          data.push(json);
        });
      }
    });
    return data;
  }

  /**
   * 把例如12:30转换为1230
   * @param data 小时*100+分钟
   */
  public convertTimesToString(data: string): number {
    const times = data.split(":");
    const str = Number(times[0]) * 100 + Number(times[1]);
    return str;
  }

  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  public convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }

  created() {
    if (this.type == "delay") {
      this.tableColumnsAC = [
        {
          title: i18n.t("addRatamanage.slotFlag"),
          key: "slotFlag",
          resizable: true,
          width: 120,
          slot: "slotFlag"
        },
        {
          title: i18n.t("addRatamanage.slotElecPrice"),
          key: "slotDelayPrice",
          resizable: true,
          slot: "slotElecPrice",
          width: 120
        },
        {
          title: i18n.t("addRatamanage.timeValue"),
          key: "timeValue",
          resizable: true,
          minWidth: 130,
          slot: "timeValue"
        }
      ];
    }
  }
}
